import React, { useState } from 'react';
import { UPDATE_UNASSIGNED_ASSETS, COMBINED_QUERY } from '../api';
import { Button, FormControl, Modal } from 'react-bootstrap';
import UnassignedAssetsGrid from './UnassignedAssetsGrid';
import { useMutation, useQuery } from '@apollo/client';

const UnassignedAssetsGridWrapper = () => {
  //TODO Get InventoryYear from settings
  // const [owners, setOwners] = useState([]);
  // const [depts, setDepts] = useState([]);
  const [source] = useState('Non-Capital');
  const [year] = useState(new Date().getFullYear().toString());
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [selectedDept, setSelectedDept] = useState(null);
  const [showModal, setShowModal] = useState(false);
  // const invYearQuery = useQuery(GET_INVENTORY_YEAR, { variables: { setting: 'Inventory Year' } });
  const { data, loading, error } = useQuery(COMBINED_QUERY, { variables: { source: source, year: year } });
  const [updateAssets] = useMutation(UPDATE_UNASSIGNED_ASSETS);

  if (error) {
    return <div>error</div>;
  }

  if (loading) {
    return <div>Loading</div>;
  }

  const handleOwnerChange = (e) => {
    setSelectedOwner(e.target.value || null);
  };

  const handleDeptChange = (e) => {
    setSelectedDept(e.target.value || null);
  };

  const validateSelection = () => {
    if (!selectedDept || !selectedOwner) {
      if (!selectedDept && !selectedOwner) {
        alert('No Owner or Department Selected');
      } else if (!selectedDept) {
        alert('No Department Selected');
      } else {
        alert('No Owner Selected');
      }
      return;
    }

    handleOpen();
  };

  const handleSubmit = () => {
    // e.preventDefault();
    
    updateAssets({ variables: { owner: selectedOwner, department: parseInt(selectedDept), year: year, source: source } }).catch((err) =>
      console.log('Error: /frontend/src/pages/Admin/UnassignedAssets/components//handleSubmit', err)
    );
    setSelectedOwner(null);
    handleClose();
  };

  const handleClose = () => setShowModal(false);
  const handleOpen = () => setShowModal(true);

  return (
    <div className='form-inline'>
      {/* <form className='form-inline' onSubmit={handleSubmit}> */}
      <label className='ml-5'>Assign all assets with physical owner</label>
      <FormControl as='select' id='owner' className='mr-sm-2 ml-2 w-auto' value={selectedOwner || ''} onChange={(e) => handleOwnerChange(e)} required>
        <option key={-1} value={''}>
          -- Select Owner --
        </option>
        {data.unassignedOwners.map((unassignedOwner) => (
          <option key={unassignedOwner.Owner} value={unassignedOwner.Owner}>
            {unassignedOwner.Owner}
          </option>
        ))}
      </FormControl>
      <label>to department</label>
      <FormControl
        as='select'
        id='department'
        className='mr-sm-2 ml-2 w-auto'
        value={selectedDept || ''}
        onChange={(e) => handleDeptChange(e)}
        required>
        <option key={-1} value={''}>
          -- Select Department --
        </option>
        {data.readAllDepartments.map(({ id, Abbreviation, Name }) => (
          <option key={id} value={id}>
            {Abbreviation}: {Name}
          </option>
        ))}
      </FormControl>
      <Button variant='primary' /* type='submit' */ onClick={validateSelection}>
        Save and Update Assets
      </Button>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Body>
          Selected Department: {selectedDept}, Selected Owner: {selectedOwner}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='outline-secondary' onClick={handleClose}>
            Cancel
          </Button>
          <Button variant='success' onClick={handleSubmit}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <UnassignedAssetsGrid selectedOwner={selectedOwner} refresh={true} />
      {/* </form> */}
    </div>
  );
};

export default UnassignedAssetsGridWrapper;
